//ez a komponens egy ízléses, betöltő ikont jelenít meg a felhasználó számára, amíg az alkalmazás betölti a tartalmat.

import React from 'react';
import { Stack } from '@mui/material';
import { InfinitySpin } from 'react-loader-spinner';

const Loader: React.FC = () => (
  /* A betöltő ikon megjelenítése, és középre igazítása egy stack segítségével */
  <Stack direction="row" justifyContent="center" alignItems="center" width="100%">
    {/* Az ikon egy végtelen szimbólum */}
    <InfinitySpin color="grey" />
  </Stack>
);

export default Loader;
